<template>
	<v-card>
		<v-form ref='form' v-model='isFormValid'>
			<v-card elevation='2' tile>
				<v-card-title class='headline elevation-2 font-weight-light primary secondary mb-4'>
					{{ title }}
					<v-spacer />
					<v-btn @click='$emit("submit",undefined)' icon>
						<v-icon>mdi-close-circle</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<component :data='dialogData' :is='component' />
				</v-card-text>
			</v-card>
		</v-form>
		<v-divider></v-divider>
		<v-card></v-card>
		<v-card-actions style='background-color: lightgray !important'>
			<v-spacer />
			<DeleteButton @doDelete='$emit("submit", { action: "remove" })' v-if='!hideDelete' />
			<SaveButton @click.native='$emit("submit", { action: "save", dialogData })' />
		</v-card-actions>
	</v-card>
</template>

<script>
import DeleteButton from '@/components/ui/DeleteButton'
import SaveButton from '@/components/ui/SaveButton'

export default {
	name: 'DialogEdit',

	props: {
		title: String,
		data: [Object, String],
		component: Object,
		hideDelete: Boolean,
	},

	components: {
		DeleteButton,
		SaveButton,
	},

	data() {
		return {
			isFormValid: false,
			dialogData: {},
		}
	},

	created() {
		if (!this.data) {
			this.dialogData = ''
			return
		}

		// Decoupling
		if (typeof this.data == 'undefined') {
			this.dialogData = ''
		} else {
			this.dialogData =
				typeof this.data == 'string'
					? this.data
					: JSON.parse(JSON.stringify(this.data))
		}
	},
}
</script>

<style lang="stylus">
.vuedl-layout__closeBtn
	display: none
</style>